import React from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { CookieProvider } from "./context/CookieContext";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import CookieBanner from "./components/CookieBanner";
import NewsletterPopup from "./components/NewsletterPopup";
import HomePage from "./pages/HomePage";
import BlogPage from "./pages/BlogPage";
import BlogArticlePage from "./pages/BlogArticlePage";
import LegalPage from "./pages/LegalPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <LanguageProvider>
      <CookieProvider>
        <div className="App min-h-screen bg-white overflow-x-hidden">
          <BrowserRouter>
            <Header />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogArticlePage />} />
              <Route path="/datenschutz" element={<LegalPage />} />
              <Route path="/impressum" element={<LegalPage />} />
              <Route path="/agb" element={<LegalPage />} />
              <Route path="/cookies" element={<LegalPage />} />
              <Route path="/:page" element={<LegalPage />} />
            </Routes>
            <Footer />
            <CookieBanner />
            <NewsletterPopup />
          </BrowserRouter>
          <Toaster position="bottom-right" />
        </div>
      </CookieProvider>
    </LanguageProvider>
  );
}

export default App;
